const EXTERNAL_AUDIENCE_TARGETING_TYPE = {
    MRT_CATEGORIES: 'MRT_CATEGORIES',
    MRT_DOMAINS: 'MRT_DOMAINS',
    SRT_KEYWORDS: 'SRT_KEYWORDS',
};

export default EXTERNAL_AUDIENCE_TARGETING_TYPE;
